/* eslint-disable @typescript-eslint/no-magic-numbers */
export const declination = (number: number, variants: [string, string, string] | string): string => {
  const cases = [2, 0, 1, 1, 1, 2];
  const normalizedVariants = Array.isArray(variants) ? variants : variants.split(';');

  return normalizedVariants[number % 100 > 4 && number % 100 < 20 ? 2 : cases[number % 10 < 5 ? number % 10 : 5]];
};
